import { render, staticRenderFns } from "./doc-types-preview-v2.vue?vue&type=template&id=5bb863ba&"
import script from "./doc-types-preview-v2.vue?vue&type=script&lang=js&"
export * from "./doc-types-preview-v2.vue?vue&type=script&lang=js&"
import style0 from "./doc-types-preview-v2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports